import { Typography } from '@/components/common';
import clsx from 'clsx';
import React from 'react';

interface Props {
	isCompleted: boolean;
}

export const PhaseStatusBadge: React.FC<Props> = ({ isCompleted }) => {
	const label = isCompleted ? 'Completed' : 'In Progress';

	return (
		<div
			className={clsx('py-2 px-3 bg-[#FD983433]  rounded-xl', {
				'!bg-[#40BB7126]': isCompleted,
			})}
		>
			<Typography
				type="semibold-14"
				className={clsx('text-main-orange', {
					'!text-green-120': isCompleted,
				})}
			>
				{label}
			</Typography>
		</div>
	);
};
